import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  VStack,
  Text,
  Heading,
} from '@chakra-ui/react';
import { PillButton } from './PillButton';

export interface PopupOverlayProps {
  visible: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLoading?: boolean;
  testID?: string;
}

export function PopupOverlay({
  visible,
  title,
  body,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  confirmLoading = false,
  testID,
}: PopupOverlayProps) {
  return (
    <Modal isOpen={visible} onClose={onCancel} isCentered>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
      <ModalContent
        bg="onboarding.cream"
        borderRadius="24px"
        maxW="360px"
        mx={4}
        p={6}
        data-testid={testID}
        background="linear-gradient(180deg, #fbf5ef 0%, #fbe5d8 100%)"
      >
        <ModalBody p={0}>
          <VStack spacing={4} align="stretch">
            <Heading
              as="h3"
              fontSize="20px"
              fontWeight="700"
              color="onboarding.plum"
              textAlign="center"
            >
              {title}
            </Heading>

            <Text
              fontSize="15px"
              color="onboarding.roseMuted"
              textAlign="center"
              lineHeight="22px"
            >
              {body}
            </Text>

            <VStack spacing={3} mt={2}>
              <PillButton
                label={confirmLabel}
                variant="primary"
                onPress={onConfirm}
                isLoading={confirmLoading}
                testID={testID ? `${testID}-confirm` : undefined}
              />
              <PillButton
                label={cancelLabel}
                variant="text"
                onPress={onCancel}
                testID={testID ? `${testID}-cancel` : undefined}
              />
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default PopupOverlay;
